<template>
  <div class="News">
    <transition
      name="el-zoom-in-center"
      mode="out-in"
    >
      <section class="main-section">
        <div>
          <div style="visibility:hidden">
            <el-breadcrumb
              separator="/"
              class="breadcrumb"
            >
              <el-breadcrumb-item :to="{ path: '/' }">
                首頁
              </el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/News' }">
                發生車禍
              </el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/News' }">
                sdadsasdadsdasdsa
              </el-breadcrumb-item>
              <el-breadcrumb-item>
                dasdadsasadsdsaads
              </el-breadcrumb-item>
            </el-breadcrumb>
            <el-button
              type="primary"
              @click="$router.push('/News')"
            >
              上一步
            </el-button>
          </div>
          <el-row
            :gutter="30"
            class="inpage"
          >
            <el-col
              :sm="6"
              :xs="24"
            >
              <transition
                enter-active-class="animate__animated animate__zoomIn"
                leave-active-class="animate__animated animate__zoomOut"
              >
                <div
                  v-if="pageShow"
                  style="max-height:75vh;overflow-y: overlay"
                >
                  <el-button
                    v-for="(page, index) in $store.state.newsTable"
                    :key="index"
                    class="page-sidebar"
                    @click="changePage(index)"
                  >
                    <span> {{ page.news_title }}</span>
                  </el-button>
                </div>
              </transition>
            </el-col><br>
            <el-col
              :sm="18"
              :xs="24"
              style="overflow-y: hidden"
            >
              <el-container
                v-loading="loading"
                class="content-container"
              >
                <div class="time-and-operation">
                  <div class="news-time">
                    新增時間：{{ createTime }} |<br> 更新時間：{{ updateTime }}
                  </div>
                  <div v-if="accessRight">
                    <el-popover
                      trigger="click"
                      placement="bottom-end"
                      :width="170"
                    >
                      <template #reference>
                        <el-button
                          type="primary"
                          icon="el-icon-edit"
                          circle
                        />
                      </template>
                      <div>
                        <el-button
                          round
                          type="info"
                          size="small"
                          @click="editPost"
                        >
                          編輯文章
                        </el-button>
                        <el-popconfirm
                          confirm-button-text="確定"
                          cancel-button-text="取消"
                          icon="el-icon-info"
                          icon-color="red"
                          title="你確定要刪除嗎？"
                          @confirm="deletePost"
                        >
                          <template #reference>
                            <el-button
                              round
                              type="danger"
                              size="small"
                            >
                              刪除文章
                            </el-button>
                          </template>
                        </el-popconfirm>
                      </div>
                    </el-popover>
                  </div>
                </div>
                <transition
                  name="fade-height"
                  mode="out-in"
                >
                  <div
                    :key="compiledMarkdown"
                    class="markdown-container"
                    v-html="compiledMarkdown"
                  />
                </transition>
              </el-container>
            </el-col>
          </el-row>
        </div>
      </section>
    </transition>
  </div>
</template>

<script>
// @ is an alias to /src
// import { ref } from 'vue'
import useOverflowCheck from '@/composables/useOverflowCheck'
import axios from 'axios'
import marked from 'marked'
import { ref, reactive, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { ElMessage } from 'element-plus'
export default {
  name: 'News',
  setup () {
    const store = useStore()
    const accessRight = computed(() => {
      return store.state.userInfo.user_level === 'admin'
    })
    const activeName = ref('first')
    const router = useRouter()
    const route = useRoute()
    const pageShow = ref(false)
    const pageContent = ref('')
    const rendererMD = new marked.Renderer()
    const loading = ref(true)
    const newEditVisible = ref(false)
    const nowNew = reactive({
      news_content: '',
      news_id: '',
      news_title: '',
      update_time: '',
      user_realname: ''
    })
    marked.setOptions({
      renderer: rendererMD,
      gfm: true,
      tables: true,
      breaks: true,
      pedantic: false,
      sanitize: false,
      smartLists: true,
      smartypants: false
    })
    const updateTime = computed(() => {
      var tempDate = new Date(nowNew.update_time)
      if (tempDate !== 'Invalid Date') {
        return tempDate.toUTCString()
      } else {
        return ''
      }
    })
    const createTime = computed(() => {
      var tempDate = new Date(nowNew.create_time)
      if (tempDate !== 'Invalid Date') {
        return tempDate.toUTCString()
      } else {
        return ''
      }
    })
    function getList () {
      axios
        .get('https://api.guardian17681.com/news/post/all')
        .then(response => {
          store.commit('setNewsTable', response.data.news_list)
          Object.assign(nowNew, store.state.newsTable[0])
          loading.value = false
          pageShow.value = true
          setTimeout(() => {
            checkOverflown()
          }, 1000)
        })
    }
    // 偵測左側sidebar按鈕的內容是否超出按鈕長度，有的話，給其加上跑馬燈的動畫
    const { checkOverflown } = useOverflowCheck()
    // 此處呼叫的用意是應對重新整理的狀況，另外一個呼叫點位在useChangePage裡，切換之後計時1秒等待渲染後呼叫
    function changePage (index) {
      Object.assign(nowNew, store.state.newsTable[index])
    }
    // 檢查是不是由編輯文章跳回來的，如果是的話，重新獲取文章資料(因為資料已經是舊的了)
    if (route.params.status === 'edited') {
      ElMessage({
        message: '偵測到資料變動，重新載入資料...',
        type: 'info'
      })
      getList()
    } else {
      // 如果已經讀取到文章列表(vuex-newsTable)有內容，則直接載入，不request後端
      if (store.state.newsTable.length > 0) {
        Object.assign(nowNew, store.state.newsTable[0])
        loading.value = false
        pageShow.value = true
        setTimeout(() => {
          checkOverflown()
        }, 1000)
      } else {
        getList()
      }
    }
    const compiledMarkdown = computed(() => {
      try {
        return marked(nowNew.news_content)
      } catch (error) {
        console.log(nowNew.news_content)
      }
      return marked(nowNew.news_content)
    })
    function editPost () {
      router.push({
        name: 'NewEdit',
        query: { editId: nowNew.news_id },
        params: {
          editTitle: nowNew.news_title,
          editContent: nowNew.news_content
        }
      })
    }
    function deletePost () {
      const body = {
        news_id: nowNew.news_id
      }
      axios
        .delete('https://api.guardian17681.com/news/post/delete', {
          data: body,
          headers: { Authorization: 'Bearer ' + store.state.loginToken }
        })
        .then(response => {
          console.log(response.data.status)
          ElMessage({
            message: '文章刪除成功，重新載入資料...',
            type: 'success'
          })
          setTimeout(() => {
            Object.assign(nowNew, {
              news_content: '',
              news_id: '',
              news_title: '',
              update_time: '',
              user_realname: ''
            })
            pageShow.value = false
            loading.value = true
            getList()
          }, 2000)
        })
        .catch(error => {
          ElMessage.error('文章刪除失敗，您未擁有刪除文章的權限。')
          console.log(error)
        })
    }
    return {
      activeName,
      pageContent,
      compiledMarkdown,
      getList,
      editPost,
      deletePost,
      changePage,
      pageShow,
      loading,
      newEditVisible,
      accessRight,
      updateTime,
      nowNew,
      createTime
    }
  }
}
</script>
<style lang="scss" scoped>
:root {
  --overlen: -100%;
}
.fade-height-enter-active,
.fade-height-leave-active {
  transition: all 0.5s ease-out;
  max-height: 1000px;
}

.fade-height-enter-from,
.fade-height-leave-to {
  opacity: 0;
  max-height: 0px;
}
::v-deep .marquee {
  white-space: nowrap;
  overflow: hidden;
  box-sizing: border-box;
  span {
    --overflowLen: var(--overlen);
    display: inline-block;
    animation: marquee 4s linear infinite alternate;
  }
}
@keyframes marquee {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(var(--overflowLen));
  }
}
::-webkit-scrollbar {
  background-color: #5e77ac38;
  border-radius: 10px;
  width: 7px;
}
::-webkit-scrollbar-thumb {
  background-color: #537488;
  border-radius: 10px;
  width: 7px;
}
$phones-media: 769px;
@media only screen and (max-width: $phones-media) {
  //手機版css
  .row {
    //卡片row class
    width: 60vw;
    margin: 0;
    flex-wrap: nowrap;
    display: inline-flex;
    overflow-x: scroll;
  }
  .main-section {
    background-size: cover;
    background-position: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding: 10px;
    padding-top: 17vmin;
  }
  .News {
    background-image: url("../assets/News.jpg");
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
    min-height: 100vh;
    height: auto;
  }
  ::v-deep .el-affix--fixed {
    //強迫el-affix加上的懸浮position規則(positoin: fixed)失效(強迫蓋過)
    position: static;
  }
  .inpage {
    //文章row class
    width: 100%;
    margin-left: 0px !important;
    margin-right: 0px !important;
  }
  .page-sidebar {
    min-width: 100%;
    max-width: calc(100vw - 50px);
    margin-top: 5px;
    height: 30px;
    box-sizing: border-box;
    margin-left: 0px;
    overflow-x: hidden;
  }
  .content-container {
    //右側文章欄class
    display: inline-block;
    background-color: white;
    height: 100%;
    max-width: 100%;
    margin-top: 5px;
    border-radius: 4px;
    border: var(--el-border-base);
    border-color: var(--el-button-border-color, var(--el-border-color-base));
  }
  .main-title {
    font-size: 7vmin;
    color: white;
    filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.7));
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .time-and-operation {
    // position: absolute;
    // top: 175px;
    // right: 15px;
    // align-items: end;
    // display:none;
    .news-time {
      margin-right: 30px;
      position: relative;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.5);
      padding: 10px;
    }
  }
  ::v-deep .markdown-container {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    h1 {
      margin: 15px 0px;
      font-size: 24px;
    }
    h2 {
      font-size: 18px;
    }
    img {
      max-width: 100%;
    }
  }
}
@media only screen and (min-width: $phones-media) {
  //電腦版css
  .row {
    width: 30vw;
    margin: 0;
    flex-wrap: nowrap;
  }
  .time-and-operation {
    position: absolute;
    top: 15px;
    right: 15px;
    display: flex;
    align-items: end;
    .news-time {
      margin-right: 30px;
      position: relative;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.5);
    }
    br {
      display: none;
    }
  }
  .inpage {
    width: 80vmax;
    margin: 0;
    flex-wrap: nowrap;
  }
  .page-sidebar {
    width: 100%;
    margin-top: 5px;
    height: 30px;
    margin-left: 0px;
    overflow: hidden;
  }
  .main-section {
    background-size: cover;
    background-position: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding-top: 10vmin;
    height: 100%;
  }
  .News {
    background-image: url("../assets/News.jpg");
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
    min-height: 100vh;
    height: auto;
  }
  .main-title {
    font-size: 5vmin;
    color: white;
    filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.7));
    margin-top: 20px;
    margin-bottom: 20px;
    br {
      display: none;
    }
  }
  .content-container {
    position: relative;
    display: inline-block;
    background-color: white;
    min-height: 100px;
    height: auto;
    width: 100%;
    margin-top: 5px;
    margin-bottom: 50px;
    border-radius: 4px;
    border: var(--el-border-base);
    border-color: var(--el-button-border-color, var(--el-border-color-base));
    overflow: hidden;
    padding: 15px;
  }
  ::v-deep .markdown-container {
    width: 100%;
    h1 {
      margin: 20px 0px;
      font-size: 24px;
    }
    h2 {
      font-size: 18px;
    }
    img {
      max-width: 100%;
    }
  }
}
</style>
